import { render, staticRenderFns } from "./AddNode.vue?vue&type=template&id=5cefb234&scoped=true&"
import script from "./AddNode.vue?vue&type=script&lang=js&"
export * from "./AddNode.vue?vue&type=script&lang=js&"
import style0 from "./AddNode.vue?vue&type=style&index=0&id=5cefb234&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cefb234",
  null
  
)

export default component.exports